const theme = {
  img_http: 'https://ouzhou-file-1302887350.file.myqcloud.com/',
  color: {
    primary: '#1EAB73',
    secondary: ''
  },
  size: {},
  mixin: {
    wrapv1: `
      min-width: 1280px;
      max-width: 1920px;
    `
  }
}
export default theme
